import { lazyWithRetry } from '~/utils/lazyWithRetry'

const QualityInboxPage = lazyWithRetry(() => import('./QualityInboxPage'))

export default QualityInboxPage
